import { z } from 'zod';

const optional = z
  .string()
  .trim()
  .transform((v) => (v === '' ? undefined : v))
  .optional();

/** Every build-time variable the Mini App reads (Vite inlines `import.meta.env`). */
const schema = z.object({
  /** Public API base, e.g. https://api.example.com. Unset = same origin. */
  VITE_API_URL: optional.transform((v) => (v ?? '').replace(/\/+$/, '')),
  /** Product key when the Mini App URL has no `?p=`. */
  VITE_PRODUCT_KEY: optional.transform((v) => v ?? 'ssc'),
});

export const env = schema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_PRODUCT_KEY: import.meta.env.VITE_PRODUCT_KEY,
});
